import { Button } from '@chakra-ui/react'
import React from 'react'

function PrimaryButton({ label, isLoading, type = 'button', ...rest }) {
  return (
    <Button
      type={type}
      size="md"
      isLoading={isLoading}
      fontWeight="semibold"
      
      // Gradient Background
      bg="linear-gradient(90deg, #9f7aea 0%, #667eea 100%)"
      
      // Solid white text (no transparency!)
      color="white"
      
      // Remove bgClip entirely – we don't want gradient text
      // bgClip="text"  ← DELETE THIS LINE
      
      borderRadius="8px"
      
      // Beautiful hover effect
      _hover={{
        bg: "linear-gradient(90deg, #8b5cf6 0%, #5a67d8 100%)", // slightly darker/vibrant
        transform: "translateY(-2px)",
        boxShadow: "0 10px 25px rgba(102, 126, 234, 0.35)",
      }}
      
      _active={{
        transform: "translateY(0)",
        boxShadow: "0 4px 10px rgba(102, 126, 234, 0.2)",
      }}
      
      transition="all 0.3s ease"
      
      {...rest}
    >
      {label}
    </Button>
  )
}

export default PrimaryButton